import React from 'react';
import { limitText } from '../LatestNewsSection/utils';
import { IconPdf } from '../../components';
import css from './PdfPreview.module.css';

const PdfPreview = (props) => {
  const {
    file,
    usePreviewIcon
  } = props;

  const [pdfImage, setPdfImage] = React.useState(null);

  const getPdfImage = async () => {
    const PDFJS = window.pdfjsLib;
    if (file.type.includes('pdf')) {
      const pdf = await PDFJS.getDocument({ url: file.href });
      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 1 });
      const canvas = document.createElement('canvas');
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      const render_context = {
        canvasContext: canvas.getContext('2d'),
        viewport: viewport
      };
      await page.render(render_context).promise;
      const img = canvas.toDataURL('image/png');
      setPdfImage(img);
    }
  };

  React.useEffect(() => {
    getPdfImage();
  }, []);


  if(usePreviewIcon) {
    return (
      <a className={css.link} href="#">
        <div className={css.pdfImage}>
          <IconPdf className={css.pdfImageSpinner} />
        </div>
        <span>{limitText(file?.description || file?.name, 15)}</span>
      </a>
    )
  }
  else if (pdfImage) {
    return (
      <a className={css.link} href={file?.href} target="_blank">
        <img
         src={pdfImage} 
         className={css.pdfImage} 
         />
        <span>{limitText(file?.description || file?.name, 15)}</span>
      </a>
    )
  } else {
    return null
  }
};

export default PdfPreview;
